import {Stack, Typography} from '@mui/material';
import {StyledTextField} from '@resurs-internal/mui';
import {FieldErrors, UseFormRegister} from 'react-hook-form';
import {useTranslate} from 'hooks';
import {MonthlyDepositFormValues} from './hooks/useMonthlyDepositForm';

type MonthlyDepositAccountFieldsProps = {
  register: UseFormRegister<MonthlyDepositFormValues>;
  errors: FieldErrors<MonthlyDepositFormValues>;
  isAutogiroRegistered: boolean;
  disabled: boolean;
  onAccountFieldChange: () => void;
};

export const MonthlyDepositAccountFields = ({
  register,
  errors,
  isAutogiroRegistered,
  disabled,
  onAccountFieldChange,
}: MonthlyDepositAccountFieldsProps) => {
  const translate = useTranslate();

  const hasError = Boolean(errors.accountPrefix || errors.accountNumber);

  return (
    <Stack>
      <Typography variant={'body1'} sx={{fontWeight: 700, marginBottom: 2}}>
        {translate('savings.deposit.monthly.account-info')}
      </Typography>
      <StyledTextField
        outline={'top'}
        fullWidth
        disabled={disabled}
        label={translate('savings.deposit.monthly.account-prefix-placeholder')}
        error={hasError}
        {...register('accountPrefix', {
          required: !isAutogiroRegistered,
          onChange: onAccountFieldChange,
        })}
      />
      <StyledTextField
        outline={'bottom'}
        fullWidth
        disabled={disabled}
        label={translate('savings.deposit.monthly.account-number-placeholder')}
        error={hasError}
        {...register('accountNumber', {
          required: !isAutogiroRegistered,
          onChange: onAccountFieldChange,
        })}
      />
      {hasError && (
        <Typography variant={'body2'} color={'error'} sx={{mt: 1, px: 2}}>
          {translate('account.input.se.error.empty')}
        </Typography>
      )}
    </Stack>
  );
};
